import { STRINGS } from 'config';

const {
  TRANSCRIPTION: { ADD_TRANSCRIPTION, RESET_TRANSCRIPTION, ADD_TRANSCRIPTIONS, DELETE_TRANSCRIPTION },
} = STRINGS.REDUCERS;

interface Transcription {
  id: string;
}

export const initialTranscriptionState = {
  currentTranscription: [],
  transcriptions: [],
};

interface TranscriptionState {
  currentTranscription: string[];
  transcriptions: Transcription[];
}

interface AddTranscriptionAction {
  type: typeof ADD_TRANSCRIPTION;
  payload: string;
}

interface AddTranscriptionsAction {
  type: typeof ADD_TRANSCRIPTIONS;
  payload: Transcription[];
}

interface DeleteTranscriptionAction {
  type: typeof DELETE_TRANSCRIPTION;
  payload: string;
}

interface ResetTranscriptionAction {
  type: typeof RESET_TRANSCRIPTION;
}

type TranscriptionAction =
  | AddTranscriptionAction
  | AddTranscriptionsAction
  | DeleteTranscriptionAction
  | ResetTranscriptionAction;

export const transcriptionReducer = (state: TranscriptionState, action: TranscriptionAction) => {
  switch (action.type) {
    case RESET_TRANSCRIPTION: {
      return { ...initialTranscriptionState, transcriptions: [...state.transcriptions] };
    }
    case ADD_TRANSCRIPTION: {
      const transcription = (action as AddTranscriptionAction).payload;
      return { ...state, currentTranscription: [...state.currentTranscription, transcription] };
    }
    case ADD_TRANSCRIPTIONS: {
      const transcriptions = (action as AddTranscriptionsAction).payload;
      return { ...state, transcriptions: [...transcriptions] };
    }
    case DELETE_TRANSCRIPTION: {
      const transcriptionId = (action as DeleteTranscriptionAction).payload;
      return { ...state, transcriptions: state.transcriptions.filter(t => t.id !== transcriptionId) };
    }
    default: {
      return state;
    }
  }
};
